import Component from '../abstracts/Component';
import { trapFocusOnModal } from '../utils/TrapFocus';
import Timer from '../utils/Timer';
import OnDemandLiveRegion from '../utils/OnDemandLiveRegion';
import { OverlayScrollbars } from 'overlayscrollbars';

export default class MiniCartComponent extends Component {

  get SELECTORS() {
    return {
      minicartBtn: '[data-minicart-button]',
      showMiniCartBtn: '[data-minicart-button-show]',
      minicartContent: '[data-minicart-content]',
      minicartContentNotify: '[data-minicartnotification-content]',
      minicartIconQty: '#miniCartIconQty',
      minicartCount: '[data-mini-cart-qty]',
      minicartCloseButton: '[data-minicart-close-button]',
      removeItemBtn: '[data-js-remove-item]',
      page: '#page-wrapper',
      minicartFocusableElements: 'a,button',
      minicartCrossellingWrapper: '[data-overlayscrollbars-initialize]'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      minicartBtn: this.$component.querySelector(this.SELECTORS.minicartBtn),
      showMiniCartBtn: this.$component.querySelector(this.SELECTORS.showMiniCartBtn),
      minicartContent: this.$component.querySelector(this.SELECTORS.minicartContent),
      minicartIconQty: this.$component.querySelector(this.SELECTORS.minicartIconQty),
      minicartCount: this.$component.querySelector(this.SELECTORS.minicartCount),
      minicartContentNotify: this.$component.querySelector(this.SELECTORS.minicartContentNotify),
      removeItemBtns: this.$component.querySelectorAll(this.SELECTORS.removeItemBtn),
      page: document.querySelector(this.SELECTORS.page),
    }
  }

  async updateMinicart() {
    const url = this.dom.minicartBtn.dataset.urlMiniCart;
    await fetch(url)
    .then(response => {
      return response.text();
    })
    .then(text => {
      const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
      this.dom.minicartContent.innerHTML = htmlResponse.querySelector(this.SELECTORS.minicartContent).innerHTML;
      this.dom = this.readDOM();
      this.updateQty();
      this.removeProductMiniCart();
      this.handleKeyboardInputOnMiniCart(this.dom.minicartContent);
    })
    .catch(error => console.error(error));
  }

  updateQty() {
    this.dom.minicartIconQty.innerHTML = this.dom.minicartCount.dataset.miniCartQty;
  }

  openQuickCartNotification(productCode) {
    const url = this.dom.minicartBtn.dataset.urlQuickCart+"?productCode="+productCode;
    fetch(url, { method: 'POST' })
    .then(response => {
      return response.text();
    })
    .then(text => {
      const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
      this.dom.page.classList.add('--overlay');
      const minicartContentNotify = this.dom.minicartContentNotify;
      minicartContentNotify.innerHTML = htmlResponse.querySelector(this.SELECTORS.minicartContent).innerHTML;
      const crossellingWrapper = this.$component.querySelector(this.SELECTORS.minicartCrossellingWrapper);
      if (crossellingWrapper) {
        this.overlayScrollBarsInstance = OverlayScrollbars(crossellingWrapper,{}); // initialises a new instance of OverlayScrollbars on the crossellingWrapper container
      }
      minicartContentNotify.classList.add("--open");
      this.dom.minicartContent.classList.add("hidden");
      trapFocusOnModal(this.$component);
      minicartContentNotify.querySelectorAll(this.SELECTORS.minicartFocusableElements).forEach(element => element.addEventListener('focusin', event => {
        this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
      }));

      const removeItemBtn = minicartContentNotify.querySelector(this.SELECTORS.removeItemBtn);
      if (removeItemBtn) {
        removeItemBtn.addEventListener("click", (event) => {
          event.preventDefault();
          const url = removeItemBtn.dataset.href;
          fetch(url, { method: 'POST' })
            .then(() => this.closeMiniCartNotify())
            .catch(error => console.error(error));
        });
      }
      this.closeMiniCartTimer = new Timer(() => this.closeMiniCartNotify(), 3000);

      const minicartCloseButton = minicartContentNotify.querySelectorAll(this.SELECTORS.minicartCloseButton);
      if (minicartCloseButton.length > 0) {
        minicartCloseButton.forEach(button => {
          button.addEventListener("click", (event) => {
            this.dom.page.classList.remove('--overlay');
            this.dom.minicartContentNotify.classList.remove("--open");
            this.dom.minicartContentNotify.innerHTML = '';
            this.$emit(this.$customEvents.POPUP_EVENTS.stopTimer);
          });
        });
      }
    })
    .catch((error) => {
      this.dom.page.classList.remove('--overlay');
      console.error(error);
    });
  }

  //remove item from quick cart --> do it every time the cart gets updated
  removeProductMiniCart() {
    if(this.dom.removeItemBtns) {
      this.dom.removeItemBtns.forEach(btn => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          const url = btn.dataset.href;
          fetch(url, { method: 'POST' })
          .then(response => {
            const newCartQty = parseInt(this.dom.minicartCount.dataset.miniCartQty, 10) - 1;
            this.dom.minicartCount.dataset.miniCartQty = newCartQty;
            this.dom.minicartIconQty.innerHTML = newCartQty;
            newCartQty >= 1 ? this.dom.minicartIconQty.classList.remove('hidden') : this.dom.minicartIconQty.classList.add('hidden');

            this.updateMinicart();
          })
          .catch(error => console.error(error));
        })
      });
    }
  }

  bindEvents() {
    // update mini cart content + cart counter
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      this.dom.minicartIconQty.classList.remove('hidden');
      const newCartQty = parseInt(this.dom.minicartCount.dataset.miniCartQty, 10) + 1;
      this.dom.minicartCount.dataset.miniCartQty = newCartQty;
      this.dom.minicartIconQty.innerHTML = newCartQty;
      this.updateMinicart();
    });

    // show quick cart notification
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      this.openQuickCartNotification(payload.productCode);
    });

    this.$on(this.$customEvents.POPUP_EVENTS.pauseTimer, () => {
      if (this.closeMiniCartTimer) {
        this.closeMiniCartTimer.pause();
      }
    });

    this.$on(this.$customEvents.POPUP_EVENTS.resumeTimer, () => {
      if (this.closeMiniCartTimer) {
        this.closeMiniCartTimer.resume();
      }
    });

    this.$on(this.$customEvents.POPUP_EVENTS.stopTimer, () => {
      if (this.closeMiniCartTimer) {
        this.closeMiniCartTimer = new Timer(() => this.closeMiniCartNotify(), 0);
      }
    });

    // communication popup timer logic //
    if(window.innerWidth >= 1024) {
      this.$component.addEventListener("mouseover", event => {
        this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
      });
      this.$component.addEventListener("mouseout", event => {
        if(document.body.dataset.jsLayerIsOpen == "false") {
          this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
        }
      });
    }

    this.showMiniCartWithChevronButton();
  }

  closeMiniCartNotify() {
    if (this.overlayScrollBarsInstance) { // destroy the OverlayScrollbars instance if it exists
      this.overlayScrollBarsInstance.destroy();
      this.overlayScrollBarsInstance = null;
    }
    this.dom.page.classList.remove('--overlay');
    this.dom.minicartContentNotify.classList.remove("--open");
    this.dom.minicartContent.classList.remove("hidden");
    this.dom.minicartContentNotify.innerHTML = '';
  }

  showMiniCartWithChevronButton() {
    this.dom.showMiniCartBtn.addEventListener("click", (event) => {
      event.preventDefault();
      const isOpening = !this.$component.classList.contains("--showContent");
      this.$component.classList.toggle("--showContent");

      // Announce to screen readers when minicart opens/closes
      if (this.liveRegion && this.$component) {
        const message = isOpening
          ? this.$component.dataset.msgOpened
          : this.$component.dataset.msgClosed;

        if (message) {
          this.liveRegion.sayMessage(message);
        }
      }
    });
  }

  handleKeyboardInputOnMiniCart(el) {
    const comp = this;
    trapFocusOnModal(el);
    el.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        comp.$component.classList.remove("--showContent");
        comp.dom.showMiniCartBtn.focus();
      }
    });
  }

  render() {
    this.log('Rendering...');
    this.dom = this.readDOM();

    // Initialize live region for screen reader announcements after DOM is ready
    if (!this.liveRegion) {
      this.liveRegion = new OnDemandLiveRegion({
        level: 'assertive',
        parent: 'body',
        idPrefix: 'minicart-live-region-',
        delay: 100
      });
    }

    // on page load retrieve the mini cart content
    this.updateMinicart().then( res => {
      this.bindEvents();
    });
  }

}
